// src/i18n/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import it from './locales/it.json';
import fr from './locales/fr.json';
import en from './locales/en.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            it: { translation: it },
            fr: { translation: fr },
            en: { translation: en },
        },
        fallbackLng: 'it',
        supportedLngs: ['it', 'fr', 'en'],
        interpolation: { escapeValue: false },
        detection: {
            order: ['localStorage', 'navigator'],
            lookupLocalStorage: 'infrapilot_lang',
            caches: ['localStorage'],
        },
    });

export default i18n;

export const changeLanguage = (lang) => {
    if (['it', 'fr', 'en'].includes(lang)) {
        i18n.changeLanguage(lang);
        localStorage.setItem('infrapilot_lang', lang);
    }
};